export interface TaskReflectionSettingInterface {
  /**
   * 参与-批次任务-批次
   */
  waggleBatchId?: number
  /**
   * 参与-测验任务-用户测验题目批次
   */
  quizReflectionBlocksBatchId?: number
}

export class TaskReflectionSetting implements TaskReflectionSettingInterface {
  /**
   * 参与-批次任务-批次
   */
  waggleBatchId?: number
  /**
   * 参与-测验任务-用户测验题目批次
   */
  quizReflectionBlocksBatchId?: number

  constructor(props: TaskReflectionSettingInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      waggleBatchId: _waggleBatchId,
      quizReflectionBlocksBatchId: _quizReflectionBlocksBatchId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.waggleBatchId = _waggleBatchId
    this.quizReflectionBlocksBatchId = _quizReflectionBlocksBatchId
  }
}
